import queryString from 'utils/queryString';
import httpRequest from 'utils/httpRequest';

import SETTINGS from '../settings';
import { getTransformedImageUrl } from '../lib/imageTransformer';

/**
 * Prepare URL with Api Gateway HOST and current query.
 * @param {string} url
 * @param {object} query
 * @returns {string}
 */
const withApiGatewayHost = (url, query = {}) => {
  return queryString.stringifyUrl(`${SETTINGS.API_GATEWAY_HOST}/${url}`, query);
};

const withApiHeaders = (headers = {}) => ({
  'X-User-Agent': SETTINGS.USER_AGENT,
  ...headers,
});

const imageApi = accessToken => ({
  /**
   * Upload image
   * @param {string} photoUrl
   * @returns {{ data: object, error: object }}
   */
  async uploadImage(photoUrl) {
    try {
      const response = await httpRequest(withApiGatewayHost('image'), {
        method: 'POST',
        headers: withApiHeaders({
          Authorization: `Token ${accessToken}`,
        }),
        body: {
          sourceUrl: photoUrl,
        },
        maximumAttempts: 5,
      });

      const json = await response.json();

      return {
        data: json.data,
      };
    } catch (error) {
      return { error };
    }
  },

  async normalizeImage(originalUrl) {
    try {
      const response = await httpRequest(getTransformedImageUrl(originalUrl, [], true), {
        headers: withApiHeaders()
      });
      const json = await response.json();
      return { data: { url: json.url } };
    } catch (error) {
      return { error };
    }
  },
});

export default imageApi;
